export default __webpack_public_path__ + "static/media/FamilyNumber1.0ce9a83c.svg";